import PropTypes from 'prop-types';

const ConfirmationModal = ({ onClose, onConfirm, message }) => {

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
      <div style={styles.headerModal}>Confirm Delete</div>
      <div className='d-flex align-items-center justify-content-center'>
        <div className=''>
          <h3>{message}</h3>
          <div style={styles.actions}>
            <button onClick={onConfirm} style={styles.button}>Confirm</button>
            <button onClick={onClose} style={styles.button}>Cancel</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

ConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  },
  modal: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    textAlign: 'center',
    width: '500px',
    height:'300px'
  },
  headerModal: {
    padding: '15px',
    textAlign: 'left',
    background:' #073c4f',
    color:' #fff',
    fontSize: '20px',
    fontWeight:'600',
    margin:'-40px',
    marginBottom:'20px',
    borderTopLeftRadius:'8px',
    borderTopRightRadius: '8px'
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px',
  },
  button: {
    padding: '10px 20px',
    borderRadius: '4px',
    margin:'10px',
    cursor: 'pointer',
    border: 'none',
  },
};

export default ConfirmationModal;
